(ns ycweb.util.sound)

(def audio-clip
  (memoize
    (fn [x]
      #?(:cljs
              (js/Audio. (str "/img/sounds/" (name x) ".wav"))
         :clj {}))))

(defn play [tag]
  "Available sound tags are:
  :back :cuckoo :dialog :ding :error :errorzap :niceerror :plop :scan :scannerbeep :shocking :warn"
  #?(:cljs
     (.play (audio-clip tag))))

(defn tts [phrase]
  #?(:cljs

     (cond
       (.-speechSynthesis js/window)
       (let [utterThis (js/SpeechSynthesisUtterance. phrase)
             synth (.-speechSynthesis js/window)]
         (set! (.-voice utterThis)
           (first
             (filter #(= (.-lang %) "en-GB")
               (.getVoices synth))))
         (.speak (.-speechSynthesis js/window) utterThis))

       (exists? js/TextToSpeechInterface)
       (.tts js/TextToSpeechInterface phrase))))